import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_17: FaireProductEntity = {
  token: "caden-lane-17",
  type: "product",
  name: "Silicone Tea Party Sets",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/8b1c68015c99377fcac3c3469e4d84aafab4f335ab7d0d11da3338f7595b2521.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 28,
  msrpDollars: 56,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
